import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { lifecycle } from 'recompose'
import { connect } from 'react-redux'

import AppLoader from 'components/AppLoader'
import UserSessionErrorView from '../views/UserSessionErrorView'

// project
import { initUserId, initializeUser } from '../actions'

import {
  getEnrollmentSession,
  getTermsAndConditionsAgreed,
  getUserId,
  getUserName,
  sessionErrorsSelector,
  sessionStarted,
  sessionIsUpdating,
} from '../selectors'

import TermsAndConditionsView from '../components/TermsAndConditionsView'

const userSessionLifecycle = lifecycle({
  componentWillMount() {
    this.props.initializeUserSession()
  },
  componentWillReceiveProps(props) {
    if (props.personPublicKey !== this.props.personPublicKey) {
      this.props.initializeUserSession()
    }
  },
})

class UserSessionContainer extends Component {
  render() {
    const {
      children,
      userSessionStarted,
      userInitializing,
      termsAndConditionsAgreed,
      hasErrors,
      enrollmentSession,
    } = this.props

    const isQLEEnrollment = Boolean(enrollmentSession.QualifyingLifeEvent)

    // First boot only.
    if (!userSessionStarted) {
      return <AppLoader />
    }

    // Re-bootstrap clears enrollment mid-flight. Keep showing `children` (not
    // T&C/error from wiped state) so mount-only effects (admin assume) do not
    // remount-loop. Stable wrapper below so toggling the loader never changes
    // the parent of `children`.
    let content = children
    if (!userInitializing) {
      if (hasErrors) {
        content = <UserSessionErrorView />
      } else if (!termsAndConditionsAgreed && !isQLEEnrollment) {
        content = <TermsAndConditionsView />
      }
    }

    return (
      <div style={{ position: 'relative', height: '100%' }}>
        <div
          aria-hidden={userInitializing ? 'true' : undefined}
          style={{
            height: '100%',
            ...(userInitializing ? { pointerEvents: 'none' } : null),
          }}
        >
          {content}
        </div>
        {userInitializing ? <AppLoader overlay /> : null}
      </div>
    )
  }
}

UserSessionContainer.displayName = 'UserSessionContainer'
UserSessionContainer.propTypes = {
  children: PropTypes.element.isRequired,
  hasErrors: PropTypes.bool,
  userSessionStarted: PropTypes.bool,
  userInitializing: PropTypes.bool,
  termsAndConditionsAgreed: PropTypes.bool,
}
UserSessionContainer.defaultProps = {
  dispatch: undefined,
  userSessionStarted: false,
  userInitializing: false,
  termsAndConditionsAgreed: undefined,
  hasErrors: false,
}

const mapStateToProps = (state) => ({
  userId: getUserId(state),
  username: getUserName(state),
  userSessionStarted: sessionStarted(state),
  userInitializing: sessionIsUpdating(state),
  hasErrors:
    !(Object.keys(getEnrollmentSession(state)).length > 0) ||
    sessionErrorsSelector(state).length > 0,
  termsAndConditionsAgreed: getTermsAndConditionsAgreed(state),
  enrollmentSession: getEnrollmentSession(state),
})

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  initializeUserSession: () => {
    dispatch(initUserId())
    dispatch(initializeUser())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(userSessionLifecycle(UserSessionContainer))
